import StickyBox from "@modules/sticky-box";
import { useAppContext } from "@context/app";
import classNames from "classnames";
import InstructorIcon from "@svg/instructor";
import Bookmark from "@svg/new-design/bookmark";
import { useLayoutContext } from "@context/layout";
import { Button } from "@shared/components";
import { BUTTON_SIZE } from "@shared/components/button";

const NonAccessSkeleton: React.FC = ({}) => {
  const { showFestivalBanner } = useAppContext();
  const hasLongHeader = showFestivalBanner;
  const { isAdmin } = useLayoutContext();

  return (
    <div className="w-full pb-12 relative">
      <div className="pb-20 mx-auto">
        <div className="w-full whitespace-nowrap flex-nowrap">
          <nav className="h-12 border-b border-fds-disable">
            <div className="container-bs flex justify-between items-center h-full ">
              <ul className="flex  justify-start animate-pulse">
                <li className="w-20 h-2 course-skeleton-bg rounded-full m-1.5" />
                <li className="mx-2 course-skeleton-li-color">/</li>
                <li className="w-20 h-2 course-skeleton-bg rounded-full m-1.5" />
                <li className="mx-2 course-skeleton-li-color">/</li>
                <li className="w-20 h-2 course-skeleton-bg rounded-full m-1.5" />
              </ul>
            </div>
          </nav>
        </div>
        <div className="relative z-0 section-container mx-auto">
          <div
            className={classNames(
              " container-bs lg:container mt-4 md:mt-6 mx-auto lg:px-4"
            )}
          >
            <div className="flex  items-start">
              <div className="lg:w-8/12  lg:pl-2.5 w-full">
                <div
                  className={
                    "relative w-full aspect-video bg-background overflow-hidden rounded-10 md:hidden"
                  }
                >
                  <div className="absolute   animate-pulse  w-full course-skeleton-bg h-full left-0 top-0"></div>
                </div>
                <div>
                  <div className="mt-8 w-2/3 h-6 course-skeleton-bg m-1.5 mb-8"></div>
                  <div className="w-full h-2 course-skeleton-bg m-3"></div>
                  <div className="w-full h-2 course-skeleton-bg m-3"></div>
                  <div className="w-full h-2 course-skeleton-bg m-3"></div>
                  <div className="w-1/3 h-2 course-skeleton-bg m-3"></div>
                </div>
                <div className="w-full h-2 course-skeleton-bg m-3 mt-10"></div>
                <div className="w-full h-2 course-skeleton-bg m-3"></div>
                <div className="w-1/4 h-2 course-skeleton-bg m-3 mt-12"></div>

                <p className="font-bold text-xl mt-10 mb-4">مدرس</p>
                <div className="rounded-lg bg-zinc-100">
                  <div className="flex p-6 flex-col md:flex-row  text-muted">
                    <InstructorIcon width={100} height={100} />
                    <div className="md:pr-3 pr-0  md:mt-0 mt-3">
                      <div className="mt-8 w-20 h-2 course-skeleton-bg  m-1.5"></div>
                      <div className=" mt-2">
                        <div className="md:w-80  w-full h-2 course-skeleton-bg m-1.5"></div>
                        <div className="md:w-80 w-full  h-2 course-skeleton-bg  m-1.5"></div>
                      </div>
                    </div>
                  </div>
                </div>
                {Array(3)
                  .fill("")
                  .map((_, index) => {
                    return (
                      <div key={index}>
                        <div className="mt-8 w-10 h-2 course-skeleton-bg  m-1.5"></div>
                        <div className="w-full h-2 course-skeleton-bg  m-1.5"></div>
                        <div className="w-full h-2 course-skeleton-bg m-1.5"></div>
                        <div className="w-full h-2 course-skeleton-bg  m-1.5"></div>
                      </div>
                    );
                  })}
                <div className="lg:hidden px-4 mt-6 overflow-hidden">
                  <div className="flex  justify-start animate-pulse">
                    <div className="w-2 h-2 course-skeleton-bg rounded-full m-1.5"></div>
                    <div className="w-2 h-2 course-skeleton-bg rounded-full m-1.5"></div>
                    <div className="w-2 h-2 course-skeleton-bg rounded-full m-1.5"></div>
                  </div>
                </div>
              </div>
              <StickyBox
                className="lg:w-1/3 w-full lg:pr-5 lg:block hidden"
                offsetTop={
                  hasLongHeader ? (isAdmin ? 220 : 170) : isAdmin ? 128 : 78
                }
              >
                <div className="shadow-md rounded-8 bg-fds-primary border  product-sidebar-sizing overflow-hidden">
                  <div className="flex-col px-5 py-4 flex justify-between">
                    <div
                      className={
                        "relative w-full aspect-video bg-background overflow-hidden rounded-10 hidden md:block mb-4"
                      }
                    >
                      <div className="absolute   animate-pulse  w-full course-skeleton-bg h-full left-0 top-0" />
                    </div>
                    <div className="flex justify-between">
                      <div className="flex items-center">
                        <div className="flex flex-col px-3">
                          <span className="text-base font-medium course-skeleton-color ">
                            <div className="flex  justify-start animate-pulse">
                              <div className="w-20 h-3 course-skeleton-bg m-1"></div>
                            </div>
                          </span>
                        </div>
                      </div>{" "}
                      <div className="flex items-center">
                        <div className="flex flex-col px-3">
                          <span className="text-base font-medium course-skeleton-color ">
                            <div className="flex  justify-start animate-pulse">
                              <div className="w-20 h-3 course-skeleton-bg  m-1"></div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-between mt-2">
                      <div className="flex items-center">
                        <div className="flex flex-col px-3">
                          <span className="text-base font-medium course-skeleton-color ">
                            <div className="flex  justify-start animate-pulse">
                              <div className="w-20 h-3 course-skeleton-bg m-1"></div>
                            </div>
                          </span>
                        </div>
                      </div>{" "}
                      <div className="flex items-center">
                        <div className="flex flex-col px-3">
                          <span className="text-base font-medium course-skeleton-color ">
                            <div className="flex  justify-start animate-pulse">
                              <div className="w-20 h-3 course-skeleton-bg  m-1"></div>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="overflow-hidden hidden lg:flex relative  flex-wrap py-4 ">
                      <div
                        className={
                          "w-full overflow-hidden flex justify-center items-center mt-4"
                        }
                      >
                        <Button size={BUTTON_SIZE.XLARGE} className="grow">
                          <div className="flex justify-center animate-pulse">
                            <div className="w-2 h-2 course-skeleton-bg rounded-full m-1"></div>
                            <div className="w-2 h-2 course-skeleton-bg rounded-full m-1"></div>
                            <div className="w-2 h-2 course-skeleton-bg rounded-full m-1"></div>
                          </div>
                        </Button>
                        <button className="mr-3 rounded-lg !w-12 h-12 disabled:opacity-50 border text-zinc-400 border-zinc-300 flex justify-center items-center ">
                          <Bookmark width={22} height={22} />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className=" mb-4 h-16  lg:mb-0 rounded-4 relative">
                    {Array(2)
                      .fill(0)
                      .map((_, index) => {
                        return (
                          <div
                            className="flex justify-between mt-2"
                            key={index}
                          >
                            <div className="flex items-center">
                              <div className="flex flex-col px-3">
                                <span className="text-base font-medium course-skeleton-color">
                                  <div className="flex  justify-start animate-pulse">
                                    <div className="w-20 h-3 course-skeleton-bg m-1"></div>
                                  </div>
                                </span>
                              </div>
                            </div>{" "}
                            <div className="flex items-center">
                              <div className="flex flex-col px-3">
                                <span className="text-base font-medium course-skeleton-color ">
                                  <div className="flex  justify-start animate-pulse">
                                    <div className="w-20 h-3 course-skeleton-bg  m-1"></div>
                                  </div>
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </StickyBox>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NonAccessSkeleton;
